const LOAD_STRIPE_PROPS = {
  betas: ['blocked_card_brands_beta_2'],
};

export { LOAD_STRIPE_PROPS };
